import { render, staticRenderFns } from "./ShootingSpot.vue?vue&type=template&id=5248d802&scoped=true"
import script from "./ShootingSpot.vue?vue&type=script&lang=js"
export * from "./ShootingSpot.vue?vue&type=script&lang=js"
import style0 from "./ShootingSpot.vue?vue&type=style&index=0&id=5248d802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5248d802",
  null
  
)

export default component.exports